import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { merge, Observable, of } from 'rxjs';
import { catchError, startWith, switchMap, tap } from 'rxjs/operators';
import { Imovel } from 'src/app/shared/models/imovel';
import { ImovelService } from 'src/app/shared/services/imovel.service';
import { EventHandler } from 'src/app/shared/util/handler.event';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { PAGE_TITLE } from 'src/globals';

@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss'],
})
export class FavoriteComponent implements OnInit {
  title: string = 'Favoritos';
  properties$: Observable<Imovel[]>;

  constructor(
    private titleService: Title,
    private propertyService: ImovelService,
    private sm: SessionManager
  ) {
    this.titleService.setTitle(`${this.title} - ${PAGE_TITLE}`);
  }

  ngOnInit(): void {
    this.properties$ = this.loadData();
  }

  /**
   * Carrega os imóveis
   */
  loadData() {
    // Evento que aguarda atualização dos favoritos
    return merge(of(null), EventHandler.builder().getFavoriteEventEmitter()).pipe(
      switchMap(() => {
        const codes = this.sm.getFavorites();
        if (!codes || codes?.length <= 0) return of([] as Imovel[]);
        return this.propertyService.getImoveis(codes);
      }),
      tap(result => this.titleService.setTitle(`${this.title} (${result?.length}) - ${PAGE_TITLE}`)),
      startWith(Array(3).fill(new Imovel())),
      catchError(error => {
        SessionManager.handleHttpError(error, `Falha ao consultar ${this.title}.`);
        return of([]);
      })
    );
  }
}
